import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { AuditLogModel } from "@/core/models/audit-log.model";

interface _AuditLogGetParams {
    search?: string;
}

@injectable()
export class AuditLogRepo extends TableRepo<AuditLogModel> {
    constructor() {
        super("/api/AuditLog");
    }

    async getData(index: number, params: _AuditLogGetParams, pageSize = 10): Promise<ApiPage<AuditLogModel>|null> {
        return await super.getData(index, params, pageSize);
    }

}